import { render, staticRenderFns } from "./compare-html.vue?vue&type=template&id=f72a79bc&scoped=true&"
import script from "./compare-html.vue?vue&type=script&lang=ts&"
export * from "./compare-html.vue?vue&type=script&lang=ts&"
import style0 from "./compare-html.vue?vue&type=style&index=0&id=f72a79bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a79bc",
  null
  
)

export default component.exports